var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146eb4",
    fillRule: "evenodd",
    d: "M23.074 12l.746-2.304c.558-1.725-.218-3.6-1.832-4.425L19.83 4.17 18.73 2.013C17.905.4 16.03-.378 14.305.181L12 .926 9.696.18c-1.724-.558-3.6.218-4.424 1.832L4.169 4.17 2.012 5.27C.398 6.096-.378 7.971.18 9.696L.926 12 .18 14.304c-.558 1.724.218 3.6 1.832 4.424L4.17 19.83l1.101 2.156c.825 1.614 2.7 2.392 4.425 1.833L12 23.073l2.304.747c1.724.558 3.6-.219 4.424-1.833l1.102-2.156 2.156-1.102c1.614-.824 2.392-2.7 1.833-4.424L23.074 12zM9.103 16.448L6.35 13.697c-.468-.468-.468-1.23 0-1.697.468-.468 1.229-.468 1.697 0l1.903 1.903L15.454 8.4c.468-.468 1.229-.468 1.697 0 .468.468.468 1.229 0 1.697l-6.352 6.351c-.468.468-1.228.468-1.696 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.f6be75f979488621984be7fa1cbfe53b.svg";
export { ForwardRef as ReactComponent };